import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_SLOT_MANAGEMENT_BASE_URL;
console.log('***API_BASE_URL***:', API_BASE_URL);

if (!API_BASE_URL) {
  console.error('API_BASE_URL is not defined in environment variables');
}

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'client-id': 'app',
    'client-secret': 'j9ppi28fxmyxiellzor',
  },
  timeout: 30000, 
});



api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');

    if (token) {
      config.headers.Authorization = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    let errorMessage = 'An unexpected error occurred';

    if (response) {
      const { status, data } = response;
      switch (status) {
        case 400: errorMessage = data?.message || 'Bad Request'; break;
        case 403: errorMessage = 'Access denied.'; break;
        case 404: errorMessage = 'Not found.'; break;
        case 500: errorMessage = 'Server error.'; break;
        default: errorMessage = data?.message || `Error: ${status}`;
      }
    } else {
      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Request timeout.';
      } else if (error.message.includes('Network Error')) {
        errorMessage = 'Network error. Please check your internet connection.';
      }
    }

    console.error('API Error:', {
      message: errorMessage,
      originalError: error,
    });

    return Promise.reject({ ...error, userMessage: errorMessage });
  }
);

export default api;
